module.exports = __webpack_public_path__ + "img/goldschmiede_ladenwerkstatt_innen.47f600a0.jpg";